import { useCallback, useState } from "react";
import { postApi } from "../../../../utils/api.ts";
import { API_RESET_PASSWORD } from "../../../../../config/Endpoints.js";
import { useNavigate } from "react-router-dom";
import type { ResetPasswordValues } from "../schemas/index.ts";

interface ResetPasswordResponse {
  message: string;
}

interface UseResetPasswordReturn {
  loading: boolean;
  error: string | null;
  reset: (values: ResetPasswordValues, email: string, token: string) => Promise<void>;
}

const ERROR_AUTO_CLEAR_MS = 4000;

export function useResetPassword(): UseResetPasswordReturn {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const reset = useCallback(
    async (values: ResetPasswordValues, email: string, token: string) => {
      setLoading(true);
      setError(null);
      try {
        const { data } = await postApi<ResetPasswordResponse>(
          `${API_RESET_PASSWORD}?email=${email}&password=${encodeURIComponent(
            values.password,
          )}&token=${token}`,
          undefined,
          {},
        );

        navigate("/", {
          state: {
            message: data?.message || "Password reset successfully!",
          },
        });
      } catch (e: any) {
        const message = e.message ?? "Something went wrong";
        setError(message);
        window.setTimeout(() => setError(null), ERROR_AUTO_CLEAR_MS);
      } finally {
        setLoading(false);
      }
    },
    [navigate],
  );

  return { loading, error, reset };
}
